 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		28: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		28: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"1":"Files~Formation~Formations~Player~Players~Projects~Team~Teams~TrackManager~User~Users~Venue~Venues","2":"Files~Formations~Players~Projects~Teams~TrackManager~Users~Venues","3":"Files~Projects~TrackManager","4":"Console~Project","5":"lang-it","6":"lang-ru","7":"AnalysisManager","8":"Console","9":"Error","10":"Files","11":"Formation","12":"Formations","13":"GameSettings","14":"Login","15":"Player","16":"Players","17":"Project","18":"Projects","19":"Settings","20":"Team","21":"Teams","22":"TrackManager","23":"User","24":"Users","25":"Venue","26":"Venues"}[chunkId]||chunkId) + "." + {"1":"cb4a3d07a0b72b43ba27","2":"3f6171bc938dcf0f7b0b","3":"851d7a88461a0606bf63","4":"4b21f4888406780c85f0","5":"3c1c13ecc8ba05866904","6":"be9044c5bb139c08beec","7":"6cd428ceae9d315c4461","8":"dcd68f713adae3724fe3","9":"002dc67df2acc36bdcc1","10":"5f15e3dae270d012cc1b","11":"c3579c5ebee5aa15fddd","12":"ba8806957358d292e98e","13":"4873f998a37e5d9a3cfd","14":"643d830ce7594c1dfba3","15":"12f5c0a9038334cccacd","16":"2ed79a7ad683ab442d38","17":"fa92ef9fdc91f3b94c28","18":"551a8ee1faf795e9c629","19":"b3658911e7f3e9eaa78f","20":"24305e08897aa9117f6c","21":"02f456a556d8a1fd719d","22":"38848b6043777fdc863e","23":"63d3f0dd0e036fd9239c","24":"66ef3a9ed221ffa11ccc","25":"2cb4a6b8b71573c327a1","26":"6ccf15e095d8d6771ee5","29":"0f74d344d4a153165e22","30":"5c39be44e1ef2c7540d7","31":"aa6c1f57683302f51d72","32":"10d79a1e5709d0678d95","33":"ee96379ebde8fdbac7d0","34":"fe55de15a37432f55d59","35":"99bc1b8743f25bd0917c","36":"c5b3020c911f8b488176","37":"d430714eedb45f700e8a","38":"ffb27a181a5b3ebf22cf","39":"d92ee740fcccea99e408","40":"538d1bccaedc6cafe269","41":"96b144133d1433e97803","42":"8946807ade61f8424d0e","43":"bf520a729c8051954cb9","44":"7bfa428478d32a496e13","45":"a6df8984e24a0f25fc80","46":"5892de9433b7ab76b288","47":"d3d9b6fef4fce1e021f0","48":"089729e87c16fdc1a945","49":"027ce9f2d612a4696cf4","50":"68dc1f07b553bf39a613","51":"5d37bca82baaaea78ea0","52":"a9a5273c8463e1525622","53":"4bb82f2f70f95094d2d3","54":"54e4a79c200aed0ea5a0","55":"f32b536f19ccad7851f5","56":"c687a6c4d7721ae0c75f","57":"4f647e407c0f71ba90c8","58":"a611aa9282f6bc1bfc4f","59":"d430d608d878639bfd72","60":"0d9d1e340ffe93c6bf73","61":"02ac8a956fe63e8adeeb","62":"86eedb87efcb36bb6a42","63":"8078180d260575c2ec6d","64":"aeda2b2299e957cffd15","65":"572481756fc3995885c0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1,"2":1,"3":1,"4":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"18":1,"19":1,"20":1,"22":1,"23":1,"25":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"1":"Files~Formation~Formations~Player~Players~Projects~Team~Teams~TrackManager~User~Users~Venue~Venues","2":"Files~Formations~Players~Projects~Teams~TrackManager~Users~Venues","3":"Files~Projects~TrackManager","4":"Console~Project","5":"lang-it","6":"lang-ru","7":"AnalysisManager","8":"Console","9":"Error","10":"Files","11":"Formation","12":"Formations","13":"GameSettings","14":"Login","15":"Player","16":"Players","17":"Project","18":"Projects","19":"Settings","20":"Team","21":"Teams","22":"TrackManager","23":"User","24":"Users","25":"Venue","26":"Venues"}[chunkId]||chunkId) + "." + {"1":"cb4a3d07a0b72b43ba27","2":"3f6171bc938dcf0f7b0b","3":"851d7a88461a0606bf63","4":"4b21f4888406780c85f0","5":"3c1c13ecc8ba05866904","6":"be9044c5bb139c08beec","7":"6cd428ceae9d315c4461","8":"dcd68f713adae3724fe3","9":"002dc67df2acc36bdcc1","10":"5f15e3dae270d012cc1b","11":"c3579c5ebee5aa15fddd","12":"ba8806957358d292e98e","13":"4873f998a37e5d9a3cfd","14":"643d830ce7594c1dfba3","15":"12f5c0a9038334cccacd","16":"2ed79a7ad683ab442d38","17":"fa92ef9fdc91f3b94c28","18":"551a8ee1faf795e9c629","19":"b3658911e7f3e9eaa78f","20":"24305e08897aa9117f6c","21":"02f456a556d8a1fd719d","22":"38848b6043777fdc863e","23":"63d3f0dd0e036fd9239c","24":"66ef3a9ed221ffa11ccc","25":"2cb4a6b8b71573c327a1","26":"6ccf15e095d8d6771ee5","29":"0f74d344d4a153165e22","30":"5c39be44e1ef2c7540d7","31":"aa6c1f57683302f51d72","32":"10d79a1e5709d0678d95","33":"ee96379ebde8fdbac7d0","34":"fe55de15a37432f55d59","35":"99bc1b8743f25bd0917c","36":"c5b3020c911f8b488176","37":"d430714eedb45f700e8a","38":"ffb27a181a5b3ebf22cf","39":"d92ee740fcccea99e408","40":"538d1bccaedc6cafe269","41":"96b144133d1433e97803","42":"8946807ade61f8424d0e","43":"bf520a729c8051954cb9","44":"7bfa428478d32a496e13","45":"a6df8984e24a0f25fc80","46":"5892de9433b7ab76b288","47":"d3d9b6fef4fce1e021f0","48":"089729e87c16fdc1a945","49":"027ce9f2d612a4696cf4","50":"68dc1f07b553bf39a613","51":"5d37bca82baaaea78ea0","52":"a9a5273c8463e1525622","53":"4bb82f2f70f95094d2d3","54":"54e4a79c200aed0ea5a0","55":"f32b536f19ccad7851f5","56":"c687a6c4d7721ae0c75f","57":"4f647e407c0f71ba90c8","58":"a611aa9282f6bc1bfc4f","59":"d430d608d878639bfd72","60":"0d9d1e340ffe93c6bf73","61":"02ac8a956fe63e8adeeb","62":"86eedb87efcb36bb6a42","63":"8078180d260575c2ec6d","64":"aeda2b2299e957cffd15","65":"572481756fc3995885c0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
